import {ErrorResponse} from "../types/StudioAPITypes";
import {DEFAULT_REQUEST_OPTIONS} from "../utils/constants";
import {RequestOptions} from "../types/Types";

export const FETCH_PROEJCTS_BASE = 'FETCH_PROJECTS';
export const FETCH_PROJECTS_BEGIN   = `${FETCH_PROEJCTS_BASE}_BEGIN`;
export const FETCH_PROJECTS_SUCCESS = `${FETCH_PROEJCTS_BASE}_SUCCESS`;
export const FETCH_PROJECTS_FAILURE = `${FETCH_PROEJCTS_BASE}_FAILURE`;
export const UPDATE_PROJECTS_FILTER = 'UPDATE_PROJECTS_FILTER'

export const fetchProjectsBegin = (options: RequestOptions = DEFAULT_REQUEST_OPTIONS) => ({
  type: FETCH_PROJECTS_BEGIN,
  options: options
});

export const fetchProjectsSuccess = (projects: any) => ({
  type: FETCH_PROJECTS_SUCCESS,
  payload: { projects }
});

export const fetchProjectsError = (error: ErrorResponse) => ({
  type: FETCH_PROJECTS_FAILURE,
  payload: { error }
});

export const updateProjectsFilter = (filter: string) => ({
  type: UPDATE_PROJECTS_FILTER,
  filter: filter
})
